import * as React from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { Container } from '../../../layout/Container';
import { Button } from '../../../ui/button/Button';
import { ButtonGroup } from '../../../ui/button/ButtonGroup';
import { ButtonGroupColumn } from '../../../ui/button/ButtonGroupColumn';
import { Image } from '../../../ui/image/Image';

import { Heading } from '../../../ui/text/Heading';
import { Paragraph } from '../../../ui/text/Paragraph';
import { DeliveryContainer } from '../../../containers/delivery/Container';

const StyledArticleHighlight = styled.div`
  width: 100%;
  padding: 3em 0;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 0;
  }

  @media all and (min-width: 960px) {
    .reverse {
      grid-auto-flow: dense;
      direction: rtl;
      justify-content: flex-end;
    }
    .reverse-text {
      text-align: left;
    }
    .reverse-title {
      text-align: left;
    }
  }
`;

const StyledArticleHighlightInner = styled.div`
  display: grid;

  .underline {
    margin-top: 1em;
  }

  @media all and (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 2em;

    .underline {
      margin-top: 0;
    }
  }
`;

const StyledArticleHighlightImage = styled.div`
  color: white;
  .image-overlay {
    height: 50%;
    max-height: 100px;
  }
`;

const StyledArticleHighlightText = styled.div`
  direction: ltr;
`;

interface IArticleHighlight {
  title?: string;
  text?: string;
  image?: string;
  imageOverlay?: string;
  className?: string;
  button?: {
    label?: string;
    link?: string;
  };
  alt?: string;
}

export const ArticleHighlight: React.FC<IArticleHighlight> = React.memo(
  ({ className, title, text, image, imageOverlay, button, alt }) => {
    const history = useHistory();
    return (
      <StyledArticleHighlight>
        <DeliveryContainer>
          <StyledArticleHighlightInner className={className}>
            <StyledArticleHighlightImage>
              <Image url={image || ''} alt="bilde av logo">
                {imageOverlay ? (
                  <img
                    src={imageOverlay}
                    className="image-overlay"
                    alt="nummer-logo"
                  />
                ) : null}
              </Image>
            </StyledArticleHighlightImage>
            <StyledArticleHighlightText>
              <Heading className="reverse-title" tag="h3">
                {title}
              </Heading>
              <Paragraph className="reverse-text">{text}</Paragraph>
              {button?.label && button?.link ? (
                <ButtonGroup className={className}>
                  <ButtonGroupColumn>
                    <Button
                      type="primary"
                      colorTheme="gold"
                      onClick={() => history.push(button.link as string)}
                    >
                      {button.label}
                    </Button>
                  </ButtonGroupColumn>
                </ButtonGroup>
              ) : null}
            </StyledArticleHighlightText>
          </StyledArticleHighlightInner>
        </DeliveryContainer>
      </StyledArticleHighlight>
    );
  }
);
